<template>
  <b-card
    no-body
    class="card-payment"
  >
    <b-card-body>
      <!-- form -->
      <b-form>
        <b-row>
          <b-col
            sm="12"
            style="text-align:center;font-weight: bold; font-size: 16px; font-family: cursive;"
          >
            Dependencia:  {{ dataRespuesta.dependenciaNombre }}
            <span>
              <a
                @click="generarFichaPdf"
              >
                <b-img
                  :src="imgPdfCons"
                  width="24"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Descargar"
                />
              </a>
            </span>
            <!-- <download-excel
              class="btn btn-default"
              :fields="json_fields_resultado"
              :fetch="()=>{return getFichaResultado()}"
              worksheet="Ficha"
              name="reporte_ficha_resultado.xls"
            >
              <b-img
                :src="imgExcel"
                width="24"
                data-toggle="tooltip"
                data-placement="top"
                title="Descargar Resultado de Encuesta"
              />
            </download-excel> -->
            <p>Encuesta: {{ dataRespuesta.encuestaTitulo }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            sm="12"
            style="font-weight: bold; font-size: 16px; font-family: cursive;"
          >
            Encuestado:  {{ dataRespuesta.encuestadoNombre }}
            <p> DNI: {{ dataRespuesta.encuestadoDni }}
              <br>
              Dirección: {{ dataRespuesta.encuestadoDireccion }}
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-table
              ref="refUserListTable"
              class="position-relative"
              :items="dataRespuesta.preguntaRespuesta"
              responsive
              :fields="fields"
              primary-key="id"
              show-empty
              empty-text="No se encontraron registros"
            >
              <template #cell(#)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(pregunta)="data">
                {{ data.item.pregunta }}
              </template>
              <template #cell(respuesta)="data">
                <span
                  v-if="data.item.tipoPregunta==='image'"
                >
                  <a
                    :href="`data:image/png;base64,${data.item.respuestaValor}`"
                    target="_blank"
                    download
                  >
                    <b-avatar
                      size="32"
                      :src="`data:image/jpeg;base64,${data.item.respuestaValor}`"
                    />
                  </a>
                </span>
                <span
                  v-if="data.item.tipoPregunta!=='image'&& data.item.respuestaValor!=='No Registra'"
                >
                  {{ data.item.respuestaValor }}
                </span>
                <span
                  v-if="data.item.tipoPregunta!=='image'&& data.item.respuestaValor==='No Registra'"
                  style="color:#ea5455;"
                >
                  {{ data.item.respuestaValor }}
                </span>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <br>
        <b-row>
          <b-col
            sm="12"
          >
            <b style="text-align:center;font-weight: bold; font-size: 16px; font-family: cursive;">
              Observación:
            </b> {{ dataRespuesta.observacion }}
          </b-col>
        </b-row>
        <br>
        <b-row
          v-if="dataRespuesta.multimedia.length>0"
        >
          <b-col
            sm="12"
            style="text-align:center;font-weight: bold; font-size: 16px; font-family: cursive;"
          >
            <p> Lista de Multimedia </p>
            <div
              v-for="(mult, index) in dataRespuesta.multimedia"
              :key="index"
              class="card"
              style="width: 18rem; display:inline-block;margin-left:5px"
            >
              <a
                :href="`data:image/png;base64,${mult.foto}`"
                target="_blank"
                download
              >
                <img
                  class="card-img-top img-multimedia"
                  :src="`data:image/jpeg;base64,${mult.foto}`"
                >
              </a>
              <div class="card-body">
                <p class="card-text">
                  {{ mult.nombre }}
                </p>
              </div>
            </div>
            <!-- <table>
              <tr>
                <td
                  v-for="(mult, index) in dataRespuesta.multimedia"
                  :key="index"
                >
                  <a
                    :href="`data:image/png;base64,${mult.foto}`"
                    target="_blank"
                    download
                  >
                    <b-img
                      fluid
                      class="card-img-top img-multimedia"
                      :src="`data:image/jpeg;base64,${mult.foto}`"
                    />
                  </a>
                </td>
              </tr>
            </table> -->
          </b-col>
        </b-row>
      </b-form>
      <!--/ form -->
    </b-card-body>
  </b-card>
</template>

<script>
// import axios from 'axios'
import store from '@/store'
import {
  BCard, BCardBody, BRow, BCol, BForm, BTable, BImg, BAvatar,
} from 'bootstrap-vue'
import imgExcel1 from '../../../assets/images/encuesta/excel.png'
import imgExcel2 from '../../../assets/images/encuesta/pdf-icon.png'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BTable,
    BImg,
    BAvatar,
    /* BCardHeader,
    BCardTitle,
    BLink,
    BCardText, */
  },
  emits: ['update:is-busy-respuesta', 'update:modal-show'],
  props: {
    typeAction: {
      type: String,
      required: true,
    },
    dataRespuesta: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data: () => ({
    imgExcel: imgExcel1,
    imgPdfCons: imgExcel2,
    /* json_fields_resultado: {
      PREGUNTA: 'pregunta',
      RESPUESTA: 'respuestaValor',
    }, */
    json_fields_resultado: {
      ORDEN: 'orden',
      PREGUNTA: 'pregunta',
      RESPUESTA: 'respuestaValor',
    },
    fields: [
      { key: '#', thStyle: { width: '0.1px' } },
      { key: 'pregunta', thStyle: { width: '60%' } },
      { key: 'respuesta' },
    ],
  }),
  methods: {
    async generarFichaPdf() {
      console.log(this.dataRespuesta)
      await store
        .dispatch('gsencuesta/TABLERO_INDICADOR_FICHA_PDF',
          {
            idFicha: this.dataRespuesta.idFicha,
          })
        .then(res => {
          const a = document.createElement('a')
          a.target = '_blank'
          a.href = res
          a.download = 'descargar.pdf'
          a.click()
        })
        .catch(error => {
          console.log(error)
        })
    },
    async getFichaResultado() {
      const response = this.dataRespuesta.preguntaRespuesta // await axios.get(`http://localhost:8081/gsencuesta/api/v1/tablero_indicador/pregunta_respuesta?idFicha=${this.dataRespuesta.idFicha}`)
      // console.log(this.dataRespuesta)
      return response
    },
  },
}
</script>
<style lang="scss" scoped>
.img-multimedia {
  width: 200px;
  min-width: 200px;
  height: 200px;
  min-height: 200px;
  max-height: 200px;
  padding-right: 1px;
  display: inline-block;
}
</style>
